import { cx } from '@linaria/core';
import { pluralize } from '@utils/common';
import { wrapper, label, tokens, statLine, statLineBar } from './atom.stats.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function Stats(props) {
  // calculate the percentage of correct answers for the statistics line
  const correctPercentage = Math.floor(props.correct / props.total * 100);
  const showStatLineBar = props.total > 0 && correctPercentage !== 0 && correctPercentage !== 100 && !props.skipped;
  return /*#__PURE__*/jsxs("div", {
    className: cx(wrapper, props.className),
    "data-skipped": props.skipped,
    children: [/*#__PURE__*/jsx("span", {
      className: label,
      children: props.skipped ? "Sprunget over" : /*#__PURE__*/jsxs(Fragment, {
        children: [props.correct, " ", pluralize("rigtig", props.correct, "e"), " af", " ", props.total]
      })
    }), /*#__PURE__*/jsx("div", {
      style: tokens.__override({
        correctPercentage: `${correctPercentage}%`
      }),
      className: statLine,
      children: showStatLineBar && /*#__PURE__*/jsx("div", {
        className: statLineBar
      })
    })]
  });
}

export { Stats };
//# sourceMappingURL=atom.stats.js.map
